import * as React from 'react';

const BrandLogout = () => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='18'
    height='18'
    viewBox='0 0 18 18'
    fill='none'
  >
    <path
      d='M15.6 -1.74846e-07C16.15 -1.26763e-07 16.6208 0.195833 17.0125 0.5875C17.4041 0.979166 17.6 1.45 17.6 2L17.6 16C17.6 16.55 17.4041 17.0208 17.0125 17.4125C16.6208 17.8042 16.15 18 15.6 18L9.59998 18C9.31664 18 9.07914 17.9042 8.88748 17.7125C8.69581 17.5208 8.59998 17.2833 8.59998 17C8.59998 16.7167 8.69581 16.4792 8.88748 16.2875C9.07914 16.0958 9.31664 16 9.59998 16L15.6 16L15.6 2L9.59998 2C9.31664 2 9.07914 1.90417 8.88748 1.7125C8.69581 1.52083 8.59998 1.28333 8.59998 0.999999C8.59998 0.716666 8.69581 0.479167 8.88748 0.2875C9.07914 0.0958321 9.31664 -7.24152e-07 9.59998 -6.99382e-07L15.6 -1.74846e-07ZM3.42498 8L10.6 8C10.8833 8 11.1208 8.09583 11.3125 8.2875C11.5041 8.47917 11.6 8.71667 11.6 9C11.6 9.28333 11.5041 9.52083 11.3125 9.7125C11.1208 9.90417 10.8833 10 10.6 10L3.42498 10L5.29998 11.875C5.48331 12.0583 5.57498 12.2833 5.57498 12.55C5.57498 12.8167 5.48331 13.05 5.29998 13.25C5.11664 13.45 4.88331 13.5542 4.59998 13.5625C4.31664 13.5708 4.07498 13.475 3.87498 13.275L0.299975 9.7C0.0999744 9.5 -2.4032e-05 9.26666 -2.40087e-05 9C-2.39854e-05 8.73333 0.0999745 8.5 0.299975 8.3L3.87498 4.725C4.07498 4.525 4.31248 4.42917 4.58748 4.4375C4.86248 4.44583 5.09998 4.55 5.29998 4.75C5.48331 4.95 5.57081 5.1875 5.56248 5.4625C5.55414 5.7375 5.45831 5.96667 5.27498 6.15L3.42498 8Z'
      fill='#A50010'
    />
  </svg>
);

export default BrandLogout;
